import React, { Component } from "react";
//import * as AuthService from '../../helpers/auth';

export class SettingsView extends Component {
  componentDidMount() {

  }
  render() {
    return (
      <section>
        <div>
          <h1>Settings Page</h1>
        </div>
      </section>
    );
  }
}

export default SettingsView;
